import { render, staticRenderFns } from "./createOrEdit.vue?vue&type=template&id=64e6c2a2&scoped=true&"
import script from "./createOrEdit.vue?vue&type=script&lang=ts&"
export * from "./createOrEdit.vue?vue&type=script&lang=ts&"
import style0 from "./createOrEdit.vue?vue&type=style&index=0&id=64e6c2a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6c2a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VDatePicker,VFlex,VForm,VLayout,VMenu,VSelect,VTextField,VTextarea})
